import { useMemo } from 'react'

type TraitProps = {
  value: string
  trait_type: string
}

export const Trait = ({ value, trait_type }: TraitProps) => {
  const isLegendary = useMemo(
    () => trait_type?.toLowerCase() === 'aura',
    [trait_type],
  )

  const traitType = useMemo(() => {
    return trait_type.charAt(0).toUpperCase() + trait_type.slice(1)
  }, [trait_type])

  const traitValue = useMemo(() => {
    return value.charAt(0).toUpperCase() + value.slice(1)
  }, [value])

  return (
    <div
      className={`grid grid-cols-2 bg-dark-8 p-2 rounded text-xs ${isLegendary ? 'bg-yellow-500 text-black' : ''}`}
    >
      <span className="font-bold">{traitType}</span>
      <span
        className={`text-end truncate ${isLegendary ? 'font-semibold' : ''}`}
      >
        {traitValue}
      </span>
    </div>
  )
}
